export const expertStatusOptions = [
  { label: "Invited", value: "Invited" },
  { label: "Accepted", value: "Accepted" },
  { label: "Declined", value: "Declined" },
];

export const inputRow = {
  padding: "5px",
};
